module.exports=[
  {
    "nom": "Compagnie Cet été",
    "annee": 2013,
    "adresse": "35 rue de Degré hall A",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "cttcompagnie@gmail.com",
    "www": "http://www.cttcompagnie.com",
    "reseaux": "Réseau jeune public pays de loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 70,
    "diffusion_france": 30,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Compagnie Oscar et Molière",
    "annee": 2014,
    "adresse": "Lieu Dit Bol d'Herbe - Daumeray",
    "codepostal": 49640,
    "ville": "Morannes sur Sarthe - Daumeray",
    "mail": "oscaretmoliere@gmail.com",
    "www": "http://www.oscaretmoliere.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Structures petite enfance\nMaisons de quartiers\nMilieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Oui",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [47.6884956,-0.44788]
  },
  {
    "nom": "Cinemaniak et Cie",
    "annee": 1992,
    "adresse": "35 RUE DE DEGRÉ",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "cinemaniak72@gmail.com",
    "www": "http://cinemaniak.e-monsite.com/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": "",
    "diffusion_france": "",
    "diffusion_monde": "",
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Oui",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Oui",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Zig Zag Création",
    "annee": 2006,
    "adresse": "10 rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts-de-Cé",
    "mail": "zigzagcreation@yahoo.fr",
    "www": "https://zigzagcreation.net/",
    "reseaux": "SAAS (Structures-artistes associés solidaires)\nPlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 60,
    "diffusion_france": 30,
    "diffusion_monde": 10,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Arts-Visuels",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.4288437,
      -0.5221098
    ]
  },
  {
    "nom": "Compagnie du Trépied",
    "annee": 2016,
    "adresse": "No cornette Production / 17 quai Gambetta",
    "codepostal": 49100,
    "ville": "Angers",
    "mail": "info@compagniedutrepied.com",
    "www": "http://www.compagniedutrepied.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Oui",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [47.4760333,-0.5561605]
  },
  {
    "nom": "Compagnie Omi Sissi",
    "annee": 2009,
    "adresse": "14 place de la mairie",
    "codepostal": 49130,
    "ville": "St Gemmes sur Loire",
    "mail": "cieomisissi@hotmail.fr",
    "www": "http://www.cie-omi-sissi.fr/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [47.4707151,-0.5507298]
  },
  {
    "nom": "Compagnie La Chaise",
    "annee": 2016,
    "adresse": "mairie de Mamers",
    "codepostal": 72600,
    "ville": "Mamers",
    "mail": "compagnielachaise@gmail.com",
    "www": "http://compagnielachaise.blogspot.com/",
    "reseaux": "Les enfants de Bitche",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 0,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.3765127,
      0.2459961
    ]
  },
  {
    "nom": "Compagnie A Demi-mot",
    "annee": 2004,
    "adresse": "22 rue de la Basse Lande",
    "codepostal": 44400,
    "ville": "Rezé",
    "mail": "ademimot44@gmail.com",
    "www": "http://ademimot44.wix.com/ademimot",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 59,
    "diffusion_france": 40,
    "diffusion_monde": 1,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.1806957,
      -1.5405688
    ]
  },
  {
    "nom": "Théâtre des sept Lieues",
    "annee": 1996,
    "adresse": "18 bis rue Capitaine Corhumel",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "marie@t7l.com",
    "www": "http://www.t7l.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "CITI",
    "creation": 3,
    "diffusion": 7,
    "diffusion_region": 60,
    "diffusion_france": 100,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.2188692,
      -1.5626562
    ]
  },
  {
    "nom": "Compagnie les ELéments DISPOnibles",
    "annee": 2007,
    "adresse": "Mairie de Brissac Quincé 5 rue du Maréchal Foch",
    "codepostal": 49320,
    "ville": "Brissac Loire Aubance",
    "mail": "nane.morineau@gmail.com",
    "www": "https://www.leselementsdisponibles.com/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 3,
    "diffusion_region": 90,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [47.3568118,-0.4511128]
  },
  {
    "nom": "Estran-Gioco cosî",
    "annee": 2003,
    "adresse": "11 rue de Dijon",
    "codepostal": 44800,
    "ville": "Saint-Herblain",
    "mail": "luisella.rimola@estran-giococosi.com",
    "www": "https://www.estran-giococosi.fr/",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Association Tcap, As Le Grand B",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 70,
    "diffusion_france": 30,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance\nMilieu scolaire\nDans l’espace public\nCollectivités",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2062728,
      -1.6152834
    ]
  },
  {
    "nom": "Compagnie En attendant la marée!",
    "annee": 2014,
    "adresse": "Le dix- 10 place des garennes",
    "codepostal": 44100,
    "ville": "Nantes",
    "mail": "contact@enattendantlamaree.fr",
    "www": "http://www.enattendantlamaree.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Collectif du DIX à Nantes",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 38,
    "diffusion_france": 19,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance\nMilieu scolaire",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [47.2023453,-1.5801951]
  },
  {
    "nom": "Casus Belli Théâtre",
    "annee": 2013,
    "adresse": "2 rue des métiers",
    "codepostal": 44140,
    "ville": "La Planche",
    "mail": "casus-belli.theatre@outlook.fr",
    "www": "https://www.casus-belli-theatre.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 1,
    "diffusion": 0,
    "diffusion_region": 0,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Vidéo",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.03796,
      -1.4698266
    ]
  },
  {
    "nom": "Les Dandys Production",
    "annee": 2017,
    "adresse": "3 rue de bitche",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "contact@lesdandysproduction.com",
    "www": "https://www.lesdandysproduction.com/",
    "reseaux": "Les enfants de Bitche",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Les ateliers de bitche",
    "creation": 2,
    "diffusion": 1,
    "diffusion_region": 90,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Mime",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.21174405,
      -1.54208709013756
    ]
  },
  {
    "nom": "Compagnie Il est doux de faire les fous",
    "annee": 2017,
    "adresse": "10 Rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts-de-Cé",
    "mail": "ilestdoux@outlook.fr",
    "www": "https://ilestdouxdefairelesfous.wordpress.com/",
    "reseaux": "Enjeu 49",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.4288437,
      -0.5221098
    ]
  },
  {
    "nom": "David Rolland Chorégraphies",
    "annee": 2004,
    "adresse": "16 allée du Commandant Charcot",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "info@david-rolland.com",
    "www": "http://www.david-rolland.com",
    "reseaux": "Scène d'Enfance - Assitej France",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Avec la DRAC",
    "structure_associee": "Groupe Fluo - Nantes",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 21,
    "diffusion_france": 139,
    "diffusion_monde": 4,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [47.2171548,-1.5479579]
  },
  {
    "nom": "Compagnie ECART",
    "annee": 1984,
    "adresse": "38 rue du Breil, pole associatif",
    "codepostal": 44100,
    "ville": "Nantes",
    "mail": "cieecart@yahoo.fr",
    "www": "http://www.cieecart.fr",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 0,
    "diffusion": 0,
    "diffusion_region": 0,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [47.228852,-1.5868277]
  },
  {
    "nom": "Compagnie La Fille du Vent",
    "annee": 2012,
    "adresse": "Chez Madame Chantal Proust 3 la roche- La chapelle Gaugain",
    "codepostal": 72340,
    "ville": "Loir en Vallée",
    "mail": "cie.lafilleduvent@gmail.com",
    "www": "http://marie-strehaiano.com/crbst_9.html",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Non",
    "creation": 3,
    "diffusion": 5,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [47.805646,0.6668873]
  }
]
